var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36621 8.43066C4.66931 8.18902 5.99767 8.189 7.30078 8.43066L7.43945 8.45703C9.30266 8.80284 10.6667 10.6607 10.667 12.833C10.667 14.0241 9.82745 15 8.78125 15H1.88574C0.839517 15 0 14.0241 0 12.833C0.000258434 10.6605 1.36424 8.80262 3.22754 8.45703L3.36621 8.43066ZM7.08398 9.91113C5.92444 9.69609 4.7424 9.69612 3.58301 9.91113L3.44434 9.93652C2.23254 10.1613 1.33326 11.3864 1.33301 12.833C1.33301 13.2064 1.58576 13.5 1.88574 13.5H8.78125C9.0812 13.5 9.33301 13.2064 9.33301 12.833C9.33275 11.3864 8.43364 10.1613 7.22168 9.93652L7.08398 9.91113ZM5.33301 0C7.19935 0 8.72168 1.65172 8.72168 3.70312C8.72168 5.75453 7.19935 7.40625 5.33301 7.40625C3.46685 7.40606 1.94434 5.75441 1.94434 3.70312C1.94434 1.65184 3.46685 0.000192071 5.33301 0ZM5.33301 1.5C4.19261 1.50019 3.27734 2.49272 3.27734 3.70312C3.27734 4.91353 4.19261 5.90606 5.33301 5.90625C6.4736 5.90625 7.38867 4.91365 7.38867 3.70312C7.38867 2.4926 6.4736 1.5 5.33301 1.5Z",
    fill: "#091B3D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.f285ca2934093038845e44382f2ed543.svg";
export { ForwardRef as ReactComponent };